module.exports = __webpack_public_path__ + "fonts/proximanovasoft-regular-webfont.38c6dff.woff2";